import React, { useContext } from "react";
import "../MoreMe.css";
import { MyStateContext } from "./App";
import BiobankingArticles from "./BiobankingArticles";
import ViabilityArticles from "./ViabilityArticles";
import SopArticles from "./SopArticles";

const categoryLabels = {
  En: ["Biobanking", "SOP", "Viability"],
  Fr: ["Biobanque", "Procédure Opérationnelle Standard", "Viabilité"],
  Pl: ["Biobankowanie", "Standardowe Procedury Operacyjne", "Żywotność"],
  Esp: ["Biobancos", "Procedimiento Operativo Estándar", "Viabilidad"],
};

const articleTitles = {
  En: "Articles of interest",
  Fr: "Articles d’intérêt",
  Pl: "Interesujące artykuły",
  Esp: "Artículos de interés",
};

const MoreMe = ({ selectedLanguage, title }) => {
  const {
    biobanking, setBiobanking,
    sop, setSop,
    viability, setViability,
  } = useContext(MyStateContext);

  const activeCategory = biobanking ? "biobanking" : sop ? "sop" : viability ? "viability" : null;
  const labels = categoryLabels[selectedLanguage] || categoryLabels.En;
  const sectionTitle = title || articleTitles[selectedLanguage] || articleTitles.En;

  const selectCategory = (category) => {
    const nextCategory = activeCategory === category ? null : category;
    setBiobanking(nextCategory === "biobanking");
    setSop(nextCategory === "sop");
    setViability(nextCategory === "viability");
  };

  return (
    <section className="article-interest" aria-label={sectionTitle}>
      <h3>{sectionTitle}</h3>
      <div className="ArticleCategory" aria-label="Article topics">
        {[
          ["biobanking", labels[0]],
          ["sop", labels[1]],
          ["viability", labels[2]],
        ].map(([category, label]) => (
          <button
            className="CategoryOption"
            type="button"
            key={category}
            aria-pressed={activeCategory === category}
            onClick={() => selectCategory(category)}
          >
            {label}
          </button>
        ))}
      </div>
      {biobanking && <BiobankingArticles />}
      {sop && <SopArticles />}
      {viability && <ViabilityArticles />}
    </section>
  );
};

export default MoreMe;
